(function () {
  function parsePackUnitsFromLabel(label) {
    const lower = String(label || "")
      .trim()
      .toLowerCase();
    if (!lower) return 1;

    if (
      lower.includes("חודשיים") ||
      /2\s*חודש/.test(lower) ||
      /2\s*month/.test(lower)
    ) {
      return 2;
    }

    if (
      lower.includes("שלוש") ||
      /3\s*חודש/.test(lower) ||
      /3\s*month/.test(lower)
    ) {
      return 3;
    }

    const leading = lower.match(/^(\d+)/);
    if (leading) {
      return Math.max(1, parseInt(leading[1], 10) || 1);
    }

    return 1;
  }

  function getPackUnitsFromProperties(properties) {
    if (!properties) return 0;

    if (typeof properties === "object" && !Array.isArray(properties)) {
      const raw = properties._pack_units ?? properties._pack_qty_locked;
      const units = parseInt(raw, 10);
      return units > 1 ? units : 0;
    }

    if (Array.isArray(properties)) {
      for (const property of properties) {
        const key = property?.name ?? property?.first ?? property?.[0];
        const value = property?.value ?? property?.last ?? property?.[1];
        if (key === "_pack_units" || key === "_pack_qty_locked") {
          const units = parseInt(value, 10);
          if (units > 1) return units;
        }
      }
    }

    return 0;
  }

  function getPackUnitsFromItem(item) {
    let packUnits = getPackUnitsFromProperties(item?.properties);
    if (packUnits > 1) return packUnits;

    const title = item?.variant_title || item?.title || "";
    const parsed = parsePackUnitsFromLabel(title);
    return parsed > 1 ? parsed : 0;
  }

  function getLinePackageCount(item) {
    const quantity = parseInt(item?.quantity, 10) || 0;
    if (quantity < 1) return 0;

    const packUnits = getPackUnitsFromItem(item);
    if (packUnits > 1) {
      const packages = Math.floor(quantity / packUnits);
      const remainder = quantity % packUnits;
      return packages + (remainder > 0 ? 1 : 0);
    }

    return quantity;
  }

  function getCartDisplayCount(cart) {
    if (!cart?.items?.length) return 0;

    return cart.items.reduce(
      (total, item) => total + getLinePackageCount(item),
      0,
    );
  }

  window.WdCartPackCount = {
    getCartDisplayCount,
    getLinePackageCount,
    getPackUnitsFromItem,
  };
})();
